const FETCH_SHOP_THE_LOOK_SUCCESS = 'FETCH_SHOP_THE_LOOK_SUCCESS'
const FETCH_SHOP_THE_LOOK_FAILURE = 'FETCH_SHOP_THE_LOOK_FAILURE'
const FETCH_SHOP_THE_LOOK_REQUEST = 'FETCH_SHOP_THE_LOOK_REQUEST'
const UPDATE_SHOP_THE_LOOK = 'UPDATE_`SHOP_THE_LOOK'

export { FETCH_SHOP_THE_LOOK_SUCCESS, FETCH_SHOP_THE_LOOK_FAILURE, FETCH_SHOP_THE_LOOK_REQUEST, UPDATE_SHOP_THE_LOOK }
